import React from "react";
import { View, StyleSheet } from "react-native";
import NtCaseStudyTitle from "./NtCaseStudyTitle";
import NtCaseStudySectionContainer from "./NtCaseStudySectionContainer";
import NtCaseStudyText from "./NtCaseStudyText";
import NtText from "../../../components/NtText";
import NtCaseStudyTextBold from "./NtCaseStudyTextBold";
import NtCaseStudyTextBullet from "./NtCaseStudyTextBullet";

function NtCaseStudyCunard({}) {
  return (
    <NtCaseStudySectionContainer
      title={
        "Case Study: Enhancing Crew Communication and Passenger Experience Aboard Cunard’s Queen Anne with Voxcraft"
      }
      subtitle={
        "Cunard’s magnificent new addition to its line of cruise ships, Queen Anne, has set sail, and she has been a testament to timeless evolution. With the latest communication technologies onboard from Voxcraft, it seamlessly weaves together historic legacy and cutting-edge innovation."
      }
      image={require("../../../assets/images/partners/logo_cunard.png")}
      imageStyle={{ marginLeft: -40 }}
    >
      <NtCaseStudyText>
        <NtCaseStudyTextBold>Overview:</NtCaseStudyTextBold> Cunard Line, a
        luxury British cruise operator, sought to modernize crew communication
        systems aboard its newly built flagship vessel, the Queen Anne. With a
        focus on improving safety, operational efficiency, and the overall guest
        experience, Cunard partnered with Voxcraft, a leader in communication
        intelligence and IT solutions, to deploy cutting-edge communication
        technology.
      </NtCaseStudyText>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Challenge:</NtCaseStudyTextBold> As part of its
        commitment to enhancing onboard operations, Cunard identified a need to
        upgrade from outdated digital enhanced cordless telecommunications
        (DECT) handsets. These handsets lacked the advanced features necessary
        for effective, real-time communication between officers and crew members
        on the large-scale vessel. Additionally, there was a need to address
        power consumption, minimize distractions from non-work-related{"\n\n"}
        Private & Confidential notifications, and ensure seamless communication
        utilizing rugged android phones loaded with enterprise applications.
        {"\n\n"}The Queen Anne, a 113,000-ton vessel accommodating nearly 3,000
        guests, required an enterprise-grade solution to meet these
        communication challenges while ensuring reliable connectivity for both
        crew and passengers, with special provisions for guests with
        accessibility needs.
      </NtCaseStudyText>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Solution:</NtCaseStudyTextBold> Cunard partnered
        with Voxcraft to implement their innovative mobile app, designed to
        provide a role-based communication platform for the ship’s crew. The
        solution includes voice calling, push-to-talk, and chat functionality,
        enabling streamlined coordination of tasks, schedules, and emergency
        protocols.{"\n\n"}Key features of Voxcraft’s solution include:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Rugged Android devices:</NtCaseStudyTextBold>{" "}
        Provided to the crew for enhanced durability and usability.
      </NtCaseStudyTextBullet>
      <NtCaseStudyTextBullet containerStyle={{ marginTop: 8 }}>
        <NtCaseStudyTextBold>
          Local push notification environment:
        </NtCaseStudyTextBold>{" "}
        This ensures that crew members receive mission-critical calls and
        messages onboard without internet.
      </NtCaseStudyTextBullet>
      <NtCaseStudyTextBullet containerStyle={{ marginTop: 8 }}>
        <NtCaseStudyTextBold>Offline communication:</NtCaseStudyTextBold>{" "}
        Communication remains functional without reliance on satellite or
        internet connectivity, optimizing performance and energy efficiency on
        long voyages.
      </NtCaseStudyTextBullet>
      <NtCaseStudyTextBullet containerStyle={{ marginTop: 8 }}>
        <NtCaseStudyTextBold>
          Integration with Martec’s Safety Monitoring and Control System (SMCS):
        </NtCaseStudyTextBold>{" "}
        This integration supports safety operations by relaying emergency alarms
        and suggesting appropriate procedures for handling incidents.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        Furthermore, the app integrates with the ship’s PBX system, allowing
        crew members to easily communicate with passengers. This system improves
        Private & Confidential accessibility by offering phones with specialized
        features for guests who are deaf or hard of hearing. Parents can also be
        given devices to contact childcare services, improving peace of mind
        during their stay.{"\n\n"}
        <NtCaseStudyTextBold>Results:</NtCaseStudyTextBold> With Voxcraft’s
        system in place, Cunard Line achieved:
      </NtCaseStudyText>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Enhanced crew efficiency:</NtCaseStudyTextBold>{" "}
        Crew members now have access to a reliable, feature-rich communication
        platform that allows for quick and efficient handling of both routine
        and emergency situations.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 8 }}>
        <NtCaseStudyTextBold>Improved guest experience:</NtCaseStudyTextBold>{" "}
        The seamless communication between crew and guests contributed to a
        smoother, more enjoyable onboard experience, particularly for guests
        with children and guests with special needs.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 8 }}>
        <NtCaseStudyTextBold>
          Reduced operational interruptions:
        </NtCaseStudyTextBold>{" "}
        Ensuring communications are uninterrupted by satellite outages, the
        Queen Anne’s crew can operate effectively throughout its voyages.
      </NtCaseStudyTextBullet>

      <NtCaseStudyTextBullet containerStyle={{ marginTop: 8 }}>
        <NtCaseStudyTextBold>Safety improvements:</NtCaseStudyTextBold> The
        integration with Martec’s SMCS helps ensure that the crew is
        well-prepared to handle emergencies, contributing to a safer environment
        for both crew and passengers.
      </NtCaseStudyTextBullet>

      <NtCaseStudyText style={{ marginTop: 20 }}>
        <NtCaseStudyTextBold>Conclusion:</NtCaseStudyTextBold> Through its
        partnership with Voxcraft, Cunard Line has successfully equipped the
        Queen Anne with a state-of-the-art communication system that aligns with
        its high standards of service and safety. This collaboration not only
        enhances the operational capabilities of the crew but also supports
        Cunard's long-term vision of providing an exceptional guest experience,
        bridging the gap between tradition and modern innovation. Private &
        Confidential The Queen Anne, which launched in May 2024, stands as a
        testament to Cunard’s commitment to integrating advanced technology into
        its historic legacy of ocean travel.{"\n\n"}
        <NtCaseStudyTextBold>About Voxcraft</NtCaseStudyTextBold>
        {"\n"}Voxcraft serves as a leading communication intelligence and IT
        Solutions provider, specializing in the development and operation of
        mission-critical communications networks. Additionally, it offers Low
        Earth Orbit Satellite connectivity, location services, contact tracing
        and access controls, along with cutting-edge telehealth technologies
        tailored for the global maritime industry.{"\n\n"}
        <NtCaseStudyTextBold>About Cunard</NtCaseStudyTextBold>
        {"\n"}Cunard is a luxury British cruise line, renowned for creating
        unforgettable experiences around the world. Cunard has been a leading
        operator of passenger ships on the North Atlantic since 1840,
        celebrating an incredible 183 years of operation. The Cunard experience
        is built on fine dining, hand-selected entertainment and outstanding
        service. From five-star restaurants and in-suite dining to inspiring
        guest speakers, the library and film screenings, every detail has been
        meticulously crafted to make the experience unforgettable. Destinations
        include Europe, the Caribbean, the Far East and Australia. There are
        currently three Cunard ships, Queen Mary 2, Queen Elizabeth and Queen
        Victoria. The fourth ship, Queen Anne, will enter service in 2024. This
        investment is part of the company's ambitious plans for the future of
        Cunard globally and will be the first time since 1999 that Cunard will
        have four ships in simultaneous service. Cunard is based at Carnival
        House in Southampton and has been owned since 1998 by Carnival
        Corporation & plc (NYSE/LSE: CCL; NYSE:CUK).
      </NtCaseStudyText>
    </NtCaseStudySectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {},
});

export default NtCaseStudyCunard;
